/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import { Story, Meta } from '@storybook/react/types-6-0'
import hintIcon from 'Shared/img/svg/question.svg'
import { HintGuideStorybook, HintGuideProps } from './HintGuide'
import Center from '../Center/Center'

export default {
  title: 'HintWithGuide/HintWithGuide',
  component: HintGuideStorybook,
  decorators: [story => <Center>{story()}</Center>],

  argTypes: {
    content: { control: 'GuideStorybook' },
    children: { control: <img src={hintIcon} alt="Spotify Icon" /> },
    onClick: { action: 'clicked' },
  },
} as Meta

const Template: Story<HintGuideProps> = args => <HintGuideStorybook {...args} />

export const HintGuide = Template.bind({})
HintGuide.args = {
  // @ts-ignore
  children: <img src={hintIcon} alt="FAQ" />,
  delay: 400,
  content: 'GotIt',
}
